import React from 'react'
import { CircleGauge } from 'lucide-react'

export default function CounselPracticeProgress({ progress }) {
  if (!progress) return null
  const value = Math.max(0, Math.min(100, Number(progress.progress) || 0))

  return (
    <div className="border-b border-slate-200 bg-white px-4 py-3 sm:px-6" data-testid="counsel-conversation-progress">
      <div className="mx-auto max-w-3xl">
        <div className="flex items-center justify-between gap-3 text-xs">
          <span className="inline-flex min-w-0 items-center gap-1.5 font-semibold text-slate-800">
            <CircleGauge className="h-4 w-4 shrink-0 text-teal-700" aria-hidden="true" />
            <span className="truncate">{progress.phaseLabel}</span>
          </span>
          <span className="shrink-0 font-semibold text-slate-600">{Math.round(value)}%</span>
        </div>
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-200" role="progressbar" aria-label="상담 진행률" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(value)}>
          <div className="h-full rounded-full bg-teal-600 transition-[width] duration-300" style={{ width: `${value}%` }} />
        </div>
        <div className="mt-2 grid gap-1 text-xs leading-5 text-slate-600 sm:grid-cols-3 sm:gap-4">
          <p><span className="font-semibold text-slate-700">다음 확인</span> {progress.nextFocus}</p>
          <p><span className="font-semibold text-slate-700">고객 반응</span> {progress.customerSignal}</p>
          <p><span className="font-semibold text-slate-700">마무리</span> {progress.closingStatusLabel || '확인할 내용 남음'}</p>
        </div>
      </div>
    </div>
  )
}
